import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { recordRouteChange } from "../networking/touchpoint";

export default function PreviousPathTracker() {
    // useLocation's pathname is relative to the router's basename. Read
    // window.location.pathname instead so the stored path matches what the
    // browser would send as Referer.
    const { pathname, search } = useLocation();

    useEffect(() => {
        recordRouteChange(window.location.pathname + window.location.search);
    }, [pathname, search]);

    return null;
}
